import React from 'react';
import { Link } from 'react-router-dom';
import LegalPageLayout from '../components/LegalPageLayout';

const CookiePolicyPage = () => (
  <LegalPageLayout title="Cookie Policy" lastUpdated="July 14, 2026">
    <p>
      This Cookie Policy explains how <strong>UBSAAPP</strong> (&quot;we&quot;, &quot;us&quot;), operated by{' '}
      <strong>AtoZ Auto</strong>, uses cookies and similar technologies when you visit our website or
      use our progressive web app (PWA).
    </p>
    <p>
      By continuing to use UBSAAPP, you consent to our use of cookies as described in this policy,
      unless you disable them through your browser or device settings.
    </p>

    <h2>1. What Are Cookies?</h2>
    <p>
      Cookies are small text files stored on your device when you visit a website. They help the site
      remember your preferences, keep you signed in, and understand how features are used. We also use
      local storage and session storage for similar purposes within the app.
    </p>

    <h2>2. Types of Cookies We Use</h2>
    <ul>
      <li>
        <strong>Essential cookies:</strong> Required for login, security, booking flows, and core
        platform functionality. The site cannot work properly without these.
      </li>
      <li>
        <strong>Preference cookies:</strong> Remember language choices, search history, and UI settings
        such as saved filters or display preferences.
      </li>
      <li>
        <strong>Analytics cookies:</strong> Help us understand page visits, errors, and feature usage
        so we can improve performance and reliability.
      </li>
      <li>
        <strong>Third-party cookies:</strong> Set by partners such as payment gateways (e.g. Razorpay),
        Google Translate, or map providers when you use those features.
      </li>
    </ul>

    <h2>3. How We Use Cookies</h2>
    <p>We use cookies and local storage to:</p>
    <ul>
      <li>Keep you authenticated after sign-in (JWT token and session data).</li>
      <li>Remember your last search location, dates, and guest preferences.</li>
      <li>Store wishlist and recently viewed properties on your device.</li>
      <li>Enable push notification preferences and PWA install prompts.</li>
      <li>Apply your selected language via Google Translate preferences.</li>
      <li>Process payments securely through our payment partners.</li>
    </ul>

    <h2>4. Managing Cookies</h2>
    <p>
      Most browsers let you block or delete cookies through settings. If you disable essential cookies,
      you may not be able to sign in, complete bookings, or use certain features. To manage cookies:
    </p>
    <ul>
      <li>Use your browser&apos;s privacy or security settings to block third-party or all cookies.</li>
      <li>Clear site data for UBSAAPP to remove stored preferences and login state.</li>
      <li>On mobile, use browser or PWA settings to clear cache and cookies.</li>
    </ul>

    <h2>5. Service Worker &amp; PWA Storage</h2>
    <p>
      When you install UBSAAPP as an app, a service worker may cache static files for faster loading.
      Our service worker does not intercept API requests. Push notification subscriptions are stored
      securely and can be removed from your account notification settings.
    </p>

    <h2>6. Updates to This Policy</h2>
    <p>
      We may update this Cookie Policy from time to time. The &quot;Last updated&quot; date at the top
      of this page will reflect any changes. Continued use after updates constitutes acceptance of the
      revised policy.
    </p>

    <h2>7. Contact Us</h2>
    <p>
      For questions about cookies or data use, contact us at{' '}
      <a href="mailto:info.ubsaaap@atozasindia.in">info.ubsaaap@atozasindia.in</a> or visit our{' '}
      <Link to="/privacy">Privacy Policy</Link> for more information on how we handle personal data.
    </p>
  </LegalPageLayout>
);

export default CookiePolicyPage;
